module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Vynil-3ab092ed893607cc858b0ef44372a668.svg";